export const snakeToSentenceCase = (snakeStr) => {
    if (!snakeStr) {
        return '';
    }
    const words = snakeStr?.toLowerCase().split('_');
    // Capitalize the first letter of the first word
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    // Join the words back into a single string with spaces
    return words?.join(' ')?.trim() ?? '';
};
//# sourceMappingURL=snakeToSentenceCase.js.map